module.exports = __webpack_public_path__ + "static/liquor21-c133d2aae4b04797dd4a467dbef84b2a.jpg";